<template>
  <div>
    <b-card>
      <template #header>{{
        $lang.azmoonLang.edit_exam_pack_question_question
      }}</template>
      <div class="text-center" v-show="isLoading">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </div>
      <b-form @submit.prevent="patchExamPackAzmoon" v-show="!isLoading">
        <b-row>
          <b-col cols="12">
            <b-alert :show="random_display_questions" variant="info">
              <mdicon name="information" size="20" class="mr-1" />
              <strong v-text="$lang.random_display_questions_alert" />
            </b-alert>
            <b-form-group
              v-if="!random_display_questions"
              :label="$lang.azmoonLang.order"
              label-for="order"
              :label-cols="$config.azmoon.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.azmoonLang.order"
                :rules="$v.order.$params"
              />
              <b-form-input
                id="order"
                type="number"
                min="0"
                max="999"
                :autocomplete="$lang.azmoonLang.order"
                v-model="$v.order.$model"
                :state="$v.order.$dirty ? !$v.order.$error : null"
              >
              </b-form-input>
              <div class="invalid-feedback" v-if="!$v.order.required">
                {{
                  $lang.azmoonLang.error_required.replace(
                    $lang.azmoonLang.order
                  )
                }}
              </div>
              <div
                class="invalid-feedback"
                v-if="
                  $v.order.required &&
                  (!$v.order.minLengh || !$v.order.maxLengh)
                "
              >
                {{
                  $lang.azmoonLang.error_Value.replace(
                    $lang.azmoonLang.order,
                    "0",
                    "999"
                  )
                }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              :label="$lang.azmoonLang.question_number"
              label-for="question_number"
              :label-cols="$config.azmoon.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.azmoonLang.question_number"
                :rules="$v.question_number.$params"
              />
              <b-form-input
                id="question_number"
                type="number"
                min="0"
                max="999"
                :autocomplete="$lang.azmoonLang.question_number"
                v-model="$v.question_number.$model"
                :state="
                  $v.question_number.$dirty ? !$v.question_number.$error : null
                "
              >
              </b-form-input>
              <div class="invalid-feedback" v-if="!$v.question_number.required">
                {{
                  $lang.azmoonLang.error_required.replace(
                    $lang.azmoonLang.question_number
                  )
                }}
              </div>
              <div
                class="invalid-feedback"
                v-if="
                  $v.question_number.required &&
                  (!$v.question_number.minLengh || !$v.question_number.maxLengh)
                "
              >
                {{
                  $lang.azmoonLang.error_Value.replace(
                    $lang.azmoonLang.question_number,
                    "0",
                    "999"
                  )
                }}
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              :label="$lang.azmoonLang.exam_pack_question_irt"
              label-for="exam_pack_question_irt"
              :label-cols="$config.azmoon.form.labelCol"
            >
              <requiredComponent
                slot="label"
                :label="$lang.azmoonLang.exam_pack_question_irt"
                :rules="$v.exam_pack_question_irt.$params"
              />
              <b-form-input
                id="exam_pack_question_irt"
                type="text"
                :autocomplete="$lang.azmoonLang.exam_pack_question_irt"
                v-model="$v.exam_pack_question_irt.$model"
                :state="
                  $v.exam_pack_question_irt.$dirty
                    ? !$v.exam_pack_question_irt.$error
                    : null
                "
              >
              </b-form-input>
              <div
                class="invalid-feedback"
                v-if="!$v.exam_pack_question_irt.required"
              >
                {{
                  $lang.azmoonLang.error_required.replace(
                    $lang.azmoonLang.exam_pack_question_irt
                  )
                }}
              </div>
              <div
                class="invalid-feedback"
                v-if="
                  $v.exam_pack_question_irt.required &&
                  (!$v.exam_pack_question_irt.minLengh ||
                    !$v.exam_pack_question_irt.maxLengh)
                "
              >
                {{
                  $lang.azmoonLang.error_Value.replace(
                    $lang.azmoonLang.exam_pack_question_irt,
                    "0",
                    "999"
                  )
                }}
              </div>
            </b-form-group>
          </b-col>
          <b-col>
            <div class="float-right">
              <b-button
                type="button"
                class="mr-2"
                variant="outline-danger"
                @click="cancel"
              >
                <mdicon name="close" size="20" />
                {{ $lang.azmoonLang.cancelButton }}
              </b-button>
              <b-button variant="success" type="submit">
                <mdicon name="check" size="20" />
                {{ $lang.azmoonLang.submitButton }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
export default {
  validations: {
    order: {},
    question_number: {},
    exam_pack_question_irt: {},
  },
  props: {
    exam_pack_id: {
      type: [String, Number],
      default: null,
    },
    random_display_questions: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      order: null,
      question_number: null,
      exam_pack_question_irt: null,
    };
  },
  methods: {
    cancel() {
      this.$emit("cancel", false);
    },
    async patchExamPackAzmoon() {
      try {
        this.isLoading = true;
        let payload = {
          question_number: this.question_number,
          question_order: this.order,
          exam_pack_question_irt: this.exam_pack_question_irt,
        };
        const { id } = this.item.question_info;
        let order_url =
          this.$config.api_url +
          this.$config.azmoon.exam_pack_question_order
            .replace("{0}", this.exam_pack_id)
            .replace("{1}", id);
        const response = await this.$httpService.patch(order_url, payload);
        this.$notify.success(response.data.message);
        this.$emit("getData");
        this.modalQuestion = false;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.isLoading = false;
      }
    },
    fetchData() {
      this.order = this.item.question_order;
      this.question_number = this.item.question_number;
      this.exam_pack_question_irt = this.item.exam_pack_question_irt;
    },
  },
  mounted() {
    this.fetchData();
  },
};
</script>

<style></style>
